import { useState } from "react";

import { Box, Button, Stack, Typography } from "@mui/material";

import { userState } from "../../interface/MainInterface";
import ReservationRobotCleaner from "../mobilePage/ReservationRobotCleaner";
import AdminReservationUserSearch from "./components/AdminReservationUserSearch";

interface propsType {
  userState: userState;
}

const RobotCleanerRental = (props: propsType) => {
  const [selectedReservationUser, setSelectedReservationUser] =
    useState<userState | null>(null);

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{ p: "32px", pb: "16px !important" }}
    >
      <Box className="sub-header-root" sx={{ marginBottom: 4 }}>
        <Typography variant="h5" gutterBottom className="sub-header-title">
          로봇 대여
        </Typography>
      </Box>

      <Box sx={{ flexGrow: 1 }}>
        <AdminReservationUserSearch
          userState={props.userState}
          onSelectUser={(user) => setSelectedReservationUser(user)}
          selectButtonLabel="로봇 대여"
          toolbarPlacement="static"
        />
      </Box>

      {selectedReservationUser ? (
        <Box sx={{ mt: 2 }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
            sx={{ mb: 2 }}
          >
            <Typography variant="subtitle1" fontWeight={700}>
              선택 회원 : {selectedReservationUser.userName}
            </Typography>
            <Button
              variant="outlined"
              onClick={() => setSelectedReservationUser(null)}
            >
              선택 해제
            </Button>
          </Stack>
          <ReservationRobotCleaner
            key={selectedReservationUser.userId}
            userState={props.userState}
            reservationUser={selectedReservationUser}
            adminMode
            hideNavigation
          />
        </Box>
      ) : null}
    </Stack>
  );
};

export default RobotCleanerRental;
